<mat-card class="ss-card-v2">
    <div class="ss-card-header">
        <div class="ss-card-header-main">
            <div class="ss-card-user-zone" (click)="goToUserDetails(image.user_id)">
                <user-profile [user]="cachedUser" [isName]="false"
                    [userImageClass]="'avatar-img'" [sizeAvatar]="36"></user-profile>
                <div class="ss-card-name-row">
                    <span class="screenshot-card-name">
                        {{ (cachedUser?.name || 'Unknown User') | trimName }}
                    </span>
                    <span
                        *ngIf="showBetaBadgeCached"
                        class="agent-beta-badge agent-beta-badge--name"
                        [matTooltip]="sysConfig.rustAgentNameBadgeTooltip"
                        matTooltipPosition="below"
                        (click)="$event.stopPropagation()">{{ sysConfig.rustAgentBetaBadge }}</span>
                </div>
            </div>
        </div>

        <div class="ss-card-header-actions" *ngIf="isAdmin">
            <button mat-icon-button type="button" class="ss-card-menu-btn" [matMenuTriggerFor]="ssShotMenu"
                (click)="$event.stopPropagation()" aria-label="Screenshot actions">
                <span class="material-symbols-outlined">more_vert</span>
            </button>
            <mat-menu #ssShotMenu="matMenu">
                <button mat-menu-item type="button" (click)="deleteScreenShot(image)">
                    <span class="material-symbols-outlined delete menu-ic">delete</span>
                    <span>Delete</span>
                </button>
                <button mat-menu-item type="button" (click)="downloadScreenShot(image)">
                    <span class="material-symbols-outlined download menu-ic">download</span>
                    <span>Download</span>
                </button>
            </mat-menu>
        </div>
    </div>

    <div class="ss-card-media">
        <div class="screenshot_box ss-card-image-link">
            <div class="ss-card-media-frame" #mediaFrame (click)="openPreviewImage(image)">
                <img *ngIf="displaySrc && !imgFailed"
                    [src]="displaySrc"
                    alt=""
                    class="responsive-img ss-img"
                    loading="lazy"
                    decoding="async"
                    (load)="onImgLoad()"
                    (error)="onImgError()" />
                <div class="ss-img-fallback" *ngIf="imgFailed" aria-hidden="true">
                    <span class="material-symbols-outlined">broken_image</span>
                    <span>Preview unavailable</span>
                </div>
                <div class="ss-img-fallback ss-img-fallback--pending" *ngIf="!displaySrc && !imgFailed" aria-hidden="true">
                    <span *ngIf="imgLoading" class="material-symbols-outlined">hourglass_empty</span>
                </div>
            </div>
        </div>
    </div>

    <div class="ss-card-footer">
        <div class="ss-card-footer-top">
            <div class="ss-card-app">
                <div class="ss-card-app-icon-wrap" aria-hidden="true">
                    <img *ngIf="(image | screenIconGetter) && !image._appIconErr" class="ss-card-app-icon-img" [src]="image | screenIconGetter"
                        alt="" (error)="image._appIconErr = true" loading="lazy" decoding="async" />
                    <mat-icon *ngIf="!(image | screenIconGetter) || image._appIconErr" class="ss-card-app-icon-fallback"
                        fontSet="material-symbols-outlined">{{ image | appIconGlyph }}</mat-icon>
                </div>
                <span class="ss-card-app-name" [title]="image.app_name || ''">{{
                    (image.app_name || 'Unknown app') | trimName}}
                </span>
            </div>
            <div class="screenshot-type-chip"
                [ngClass]="triggerChipClass[image.type] || 'screenshot-type-chip--periodic'" [ngSwitch]="image.type">
                <ng-container *ngSwitchCase="'app-changed'">
                    <span class="material-symbols-outlined chip-ic">swap_horiz</span>
                    <span>App switch</span>
                </ng-container>
                <ng-container *ngSwitchCase="'admin-request'">
                    <span class="material-symbols-outlined chip-ic">photo_camera</span>
                    <span>On demand</span>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <span class="material-symbols-outlined chip-ic">schedule</span>
                    <span>Periodic</span>
                </ng-container>
            </div>
        </div>
        <div class="ss-card-footer-time">
            @if (!image.showAbsoluteTime && image.timeagoInput) {
            <div class="screenshot-time-compact" [matTooltip]="image.timeDisplay?.tooltip"
                matTooltipClass="screenshot-time-tooltip" matTooltipShowDelay="300" matTooltipPosition="above">
                <span class="screenshot-time-relative-sm">{{ image.timeagoInput | timeago:true }}</span>
            </div>
            }
            @if (image.showAbsoluteTime || !image.timeagoInput) {
            <div class="screenshot-time-compact" [matTooltip]="image.timeDisplay?.tooltip"
                matTooltipClass="screenshot-time-tooltip" matTooltipShowDelay="300" matTooltipPosition="above">
                <span class="screenshot-time-primary-sm">{{ image.timeDisplay?.primaryAbsolute || image.ist_time
                    }}</span>
                @if (image.timeDisplay?.secondaryLine) {
                <span class="screenshot-time-secondary-sm">{{ image.timeDisplay.secondaryLine }}</span>
                }
            </div>
            }
            <span class="wr-ss-conduct-tag ss-card-conduct-tag"
                *ngIf="image._conductProject"
                [title]="(image._conductProject + (image._conductTask ? ' · ' + image._conductTask : '')) + ' (Click to open Conduct drawer)'"
                (click)="openConductDrawer($event)">
                <mat-icon class="wr-ss-conduct-tag-ic" fontSet="material-symbols-outlined">folder</mat-icon>
                <span class="wr-ss-conduct-tag-text">{{ image._conductProject }}</span>
            </span>
        </div>
    </div>
</mat-card>
